import { h } from "preact";
import styles from "./Header.css";

const Header = (props) => {
  return <div class={styles.header}>{props.children}</div>;
};

export default Header;
